<div class="dropdown">
  <button class="rounded-5 py-1 px-2 border-0" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
    aria-expanded="false">
    <i class="fas fa-user fs-4"></i>
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">

    @for (item of menu(); track $index) {

      @if (!item.disabled) {
      <li><a class="dropdown-item" [routerLink]="[item.route]"><i class="bi {{item.icon}} me-2"></i>{{ item.name}}</a>
      </li>


      <li>
        <hr class="dropdown-divider">
      </li>
      }
    }

    <li><a class="dropdown-item" (click)="logout()"><i class="bi bi-box-arrow-right me-2"></i>Sair</a>
    </li>
  </ul>
</div>
